import { z } from 'zod';
/** At most this many cards under one message. */
export const MAX_JIRA_CARDS = 5;
export const JiraTransitionRequest = z.object({ transitionId: z.string().min(1).max(32) });
/** `null` unassigns. */
export const JiraAssignRequest = z.object({ accountId: z.string().min(1).max(128).nullable() });
/** Plain text; `<@userId>` of someone with Jira connected becomes a real Jira mention. */
export const JiraCommentRequest = z.object({ text: z.string().trim().min(1).max(10_000) });
//# sourceMappingURL=jira.js.map